import * as React from "react";
import { Text } from "@grandvisionhq/elements";
const FramesBundleContentDescription = ({ description, className }) => /* @__PURE__ */ React.createElement(Text, { className }, description);
export {
  FramesBundleContentDescription
};
//# sourceMappingURL=FramesBundleContentDescription.js.map
